import { CreatePairDTO, Pair, PairType } from "../types/Tournaments";
import client from "./axios";

const tournamentAdminBaseUrl = "https://internal-api.getmoveapp.com/api/v1/admin/pairs";
const tournamentBaseUrl = "https://internal-api.getmoveapp.com/api/v1/pairs";

export const Pairs = {
  createPair: (body: CreatePairDTO) =>
    client.post<{ pair: Pair }>(`${tournamentAdminBaseUrl}/create`, body),
  getTournamentPairs: (tournamentId: string) =>
    client.get<{ list: Pair[] }>(`${tournamentBaseUrl}`, {
      params: {
        tournamentId,
      },
    }),
  updateTournamentPairs: (
    pairs: { player1Id?: string; player2Id?: string },
    tournamentId: string,
    type: PairType
  ) =>
    client.post<{ list: Pair[] }>(`${tournamentAdminBaseUrl}/update-pairs`, {
      pairs,
      tournamentId,
      type,
    }),
  getPair: (id: string) =>
    client.get<{ pair: Pair }>(`${tournamentBaseUrl}/${id}`),
  updatePair: (id: string, body: { player1Id?: string; player2Id?: string }) =>
    client.put<{ pair: Pair }>(`${tournamentAdminBaseUrl}/${id}`, body),
  deletePair: (id: string) =>
    client.delete<{ result: string }>(`${tournamentAdminBaseUrl}/${id}`),
};
